<!-- <template>
  <v-app>
    <v-main>      
      <Header />
      <router-view />
    </v-main>
  </v-app>
</template> -->

<template>
  <!-- <v-card> -->

  <body>
    <v-layout v-if="!$route.meta.allowAnonymous">
      <!-- NAVIGATION -->
      <v-navigation-drawer
        v-model="drawer"
        app
        :rail="rail"
        floating
        permanent
        @click="rail = false"
        elevation="2"
        theme="dark"
        color="#24293E"
      >
        <v-list>
          <!-- <v-list-item
          prepend-avatar="https://randomuser.me/api/portraits/men/85.jpg"          
          nav
          >
            <v-list-item-title>{{this.org_name}}</v-list-item-title>
            <template v-slot:append>
              <v-btn
                variant="text"
                icon="mdi-chevron-left"
                @click.stop="rail = !rail"
              ></v-btn>
            </template>
          </v-list-item>    -->

          <v-list-item nav class="first">
            <!-- <v-list-item-title>{{this.orgName}}</v-list-item-title> -->
            <h3 class="ml-3 name">POS CONSOLE</h3>
            <template v-slot:append>
              <v-btn
                variant="text"
                icon="mdi-chevron-left"
                @click.stop="rail = !rail"
                :class="{ 'rotate-btn': rail }"
              ></v-btn>
            </template>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>

        <v-list density="compact" nav>
          <v-list-item
            prepend-icon="mdi mdi-home-analytics"
            :title="$t('home')"
            value="home"
            router-link
            to="/"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi mdi-account-box"
            :title="$t('acquire')"
            value="acquirer"
            router-link
            to="/acquirer"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          ></v-list-item>

          <v-list-item
            prepend-icon="mdi-network"
            :title="$t('network config')"
            value="network_params"
            router-link
            to="/network_params"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-account-group-outline"
            :title="$t('merchant')"
            value="merchant"
            router-link
            to="/merchant"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          ></v-list-item>

          <v-list-item
            prepend-icon="mdi mdi-point-of-sale"
            :title="$t('devices')"
            value="devices"
            router-link
            to="/devices"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          ></v-list-item>

          <v-list-item
            prepend-icon="mdi mdi-download-box-outline"
            :title="$t('download history')"
            value="downloadHistory"
            router-link
            to="/downloadistory"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          ></v-list-item>
          <!-- <v-list-item
          prepend-icon="mdi mdi-devices"
          title=" Device Details"
          value="device_details"
          router-link
          to="/device-details"
           v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') || this.global_permissions.includes('ROLE_USER_ADMIN') || this.global_permissions.includes('ROLE_USER_ASSIST')"
          
        ></v-list-item> -->

          <v-list-group
            value="Cards"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_MOD_CARD')
              
            "
          >
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi mdi-cards"
                 :title="$t('cards')"
              ></v-list-item>
            </template>
            <v-list-item
              prepend-icon="mdi mdi-cards"
              :title="$t('aid')"
              value="aid"
              router-link
              to="/aid"
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-cards"
               :title="$t('capk')"
              value="capk"
              router-link
              to="/capk"
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-cards"
              :title="$t('issuer')"
              value="issuer"
              router-link
              to="/issuer"
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-cards"
              :title="$t('cardRange')"
              value="cardRange"
              router-link
              to="/cardRange"
            ></v-list-item>
          </v-list-group>

          <v-list-group
            value="Others"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_MOD_OTHERS') ||
              this.global_permissions.includes('ROLE_MOD_RECEIPT')
            "
          >
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi mdi-more"
                :title="$t('others')"
              ></v-list-item>
            </template>
            <v-list-item
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER') ||
                this.global_permissions.includes('ROLE_MOD_OTHERS')                
              "
              prepend-icon="mdi mdi-sale"
               :title="$t('discount')"
              value="discount"
              router-link
              to="/discount"
            ></v-list-item>
            <v-list-item
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER') ||
                this.global_permissions.includes('ROLE_MOD_OTHERS')                
              "
              prepend-icon="mdi mdi-decimal-increase"
               :title="$t('surcharge')"
              value="surcharge"
              router-link
              to="/surcharge"
            ></v-list-item>
            <v-list-item
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER') ||
                this.global_permissions.includes('ROLE_MOD_OTHERS')                
              "
              prepend-icon="mdi mdi-account-cancel"
               :title="$t('blacklist')"
              value="blacklist"
              router-link
              to="/blacklist"
            ></v-list-item>
            <v-list-item
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER') ||
                this.global_permissions.includes('ROLE_MOD_RECEIPT')                
              "
              prepend-icon="mdi mdi-paper-roll-outline"
               :title="$t('receipt')"
              value="receipt"
              router-link
              to="/receipt"
            ></v-list-item>
          </v-list-group>

          <v-list-item
            prepend-icon="mdi-account-group-outline"
             :title="$t('users')"
            value="users"
            router-link
            to="/users"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN')
            "
          ></v-list-item>
          <v-list-item
              prepend-icon="mdi mdi-card-account-details"
               :title="$t('license')"
              value="License"
              router-link
              to="/license"
              v-if="
               this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER') ||
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
              "
            ></v-list-item>

          <v-list-group
            value="Terminal"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi mdi-cellphone-settings"
                :title="$t('terminal')"
              ></v-list-item>
            </template>

            <v-list-item
              prepend-icon="mdi mdi-console"
              :title="$t('terminals')"
              value="terminals"
              router-link
              to="/terminal"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-domain"
              :title="$t('models')"
              value="model"
              router-link
              to="/model"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-beekeeper"
               :title="$t('suppliers')"
              value="suppliers"
              router-link
              to="/supplier"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <!-- <v-list-item  prepend-icon="mdi-account-group-outline" title="License" value="License" router-link to="/license" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"></v-list-item>      -->
          </v-list-group>

          <v-list-group
            value="Application"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi mdi-application"
                 :title="$t('application')"
              ></v-list-item>
            </template>

            <v-list-item
              prepend-icon="mdi mdi-application-cog"
               :title="$t('license App')"
              value="License App"
              router-link
              to="/licenseApp"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-application-export"
               :title="$t('app to app')"
              value="App To App"
              router-link
              to="/appToApp"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
          </v-list-group>

          <v-list-group
            value="Admin"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi mdi-security"
                 :title="$t('admin')"
              ></v-list-item>
            </template>

            <v-list-item
              prepend-icon="mdi-account-group-outline"
              :title="$t('organization')"
              value="organizations"
              router-link
              to="/organization"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-handshake"
              :title="$t('merchant activity')"
              value="merchant_activities"
              router-link
              to="/merchant-activity"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-cash-multiple"
               :title="$t('currencies')"
              value="currencies"
              router-link
              to="/currency"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-developer-board"
              :title="$t('transaction operation')"
              value="operations"
              router-link
              to="/operation"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-earth"
               :title="$t('countries')"
              value="countries"
              router-link
              to="/countries"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <v-list-item
              prepend-icon="mdi mdi-earth"
               :title="$t('featureFlag')"
              value="featureFlag"
              router-link
              to="/featureFlag"
              v-if="
                this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                this.global_permissions.includes('ROLE_STAFF_USER')
              "
            ></v-list-item>
            <!-- <v-list-item
            prepend-icon="mdi mdi-account-hard-hat"
            title="Staff"
            value="staff"
            router-link
            to="/staff"
            v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN','ROLE_STAFF_USER')"
          ></v-list-item> -->
            <!-- <v-list-item  prepend-icon="mdi-account-group-outline" title="License" value="License" router-link to="/license" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"></v-list-item>      -->
          </v-list-group>

          <!-- <v-list-group value="Users">
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                prepend-icon="mdi-account-circle"
                title="Users"
              ></v-list-item>
            </template>

            <v-list-group value="Admin">
              <template v-slot:activator="{ props }">
                <v-list-item
                  v-bind="props"
                  title="Admin"
                ></v-list-item>
              </template>
              <v-list-item prepend-icon="mdi-account-group-outline" title="Users" value="users" router-link to="/users"></v-list-item>
              <v-list-item prepend-icon="mdi-account-group-outline" title=" Roles" value="roles" router-link to="/role"></v-list-item>
            </v-list-group>
            
          </v-list-group> -->
        </v-list>

        <!-- <v-list justify-end>
          <v-list-item><h5>User: {{this.user}}</h5></v-list-item>
        </v-list> -->
        <template v-slot:append>
          <div class="pa-1">
            <!-- <v-btn style="width: 100%" plain>
              <v-icon>mdi-plus</v-icon>
              New list
            </v-btn> -->
            <!-- User: {{this.userName}} -->
          </div>
        </template>
      </v-navigation-drawer>
      <!-- APP BAR -->
      <v-app-bar color="#24293E">
        <!-- toast -->
        <vtoast ref="vtoast" />

        <!-- <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon> -->
        <v-app-bar-title>
          <div class="content">
            <!-- <p>Welcome,</p> -->
            <p>{{ $t("welcome") }}, </p>
            <p class="ml-1">{{ this.name }}!</p>
          </div>
        </v-app-bar-title>
        <v-spacer></v-spacer>

        <!-- <v-btn variant="text" icon="mdi-magnify"></v-btn>
        <v-btn variant="text" icon="mdi-filter"></v-btn> -->

        <!-- <div >
          <select v-model="$i18n.locale" class="lang_menu">
            <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
              {{ lang }}
            </option>
          </select>
        </div> -->
        <div>
          <label for="language-select" class="select-label"
            >{{ $t("select language") }}:</label
          >
          <select
            id="language-select"
            v-model="$root.$i18n.locale"
            class="lang_menu"
            @change="langChanged($i18n.locale)"
            color="white"
          >
            <!-- Default placeholder option -->
            <option disabled value="">{{ $t("changeLanguage") }}</option>

            <!-- Language options -->
            <option
              v-for="(lang, i) in languages"
              :key="`Lang${i}`"
              :value="lang.languageCode"
              color="white"
            >
              {{ lang.name }}
            </option>
          </select>
        </div>

        <!-- <v-btn variant="text" icon="mdi-dots-vertical" v-on:click="logout"></v-btn> -->
        <v-btn
          variant="text"
          icon="mdi-logout"
          color="red"
          v-on:click="this.logout()"
        ></v-btn>
      </v-app-bar>

      <!-- MAIN -->
      <v-main
        class="main"
        style="
          min-height: 300px;
          padding-top: 80px;
          padding-right: 3px;
          padding-bottom: 20px;
        "
      >
        <!-- <Header /> -->
        <!-- <router-view /> -->
        <router-view :key="componentKey" @reload="reloadChild"> </router-view>

        <!-- FOOTER -->
        <v-footer height="auto" app="false" rounded="13" class="bg-transparent">
          <!-- <v-row justify="center" no-gutters>            
            <v-col class="text-center mt-4" cols="12">
              {{ new Date().getFullYear() }} — <strong>TMS</strong>
            </v-col>
          </v-row> -->
          <v-card
            tile
            flat
            width="100%"
            color="grey-lighten-4"
            light
            height="30px"
            class="d-flex align-center justify-center"
          >
            <span class="text-overline"
              >{{ $t("footer") }}
              {{ new Date().getFullYear() }}</span
            >
          </v-card>
        </v-footer>
      </v-main>
    </v-layout>

    <v-layout v-else>
      <router-view />
    </v-layout>
    <!-- </v-card> -->
  </body>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import Header from './components/Header.vue'
//import axios from 'axios'
import vtoast from "./components/vtoast.vue";
//import { ref, watch } from 'vue';
//import { useRoute } from 'vue-router';
export default {
  setup() {
    /* const route = useRoute();
    const componentKey = ref(route.fullPath);

    // Watch for route changes
    watch(
      () => route.fullPath,
      (newPath) => {
        componentKey.value = newPath;
      }
    );

    return {
      componentKey
    }; */
  },
  name: "App",

  components: {
    //HelloWorld,
    //Header,
    vtoast,
  },
  /* watch: {
    $route() {
      // Increment the key to force the child component to reload
      this.componentKey += 1;
    }
  }, */
  data() {
    return {
      componentKey: 0, // Initial key value
      drawer: true,
      rail: false,
      user: "",
      org_name: "",
      user_status: false,
      //acquirers: [],
      //roles: [],
      roles: "",
      permissions: [],
      nameList: [],
      tokenStatus: "",

      dialog_error: false,
      dialog_success: false,

      languages: [
        { name: "English", languageCode: "en" },
        { name: "French", languageCode: "fr" },
      ],
      // langs: ['fr', 'en']
    };
  },

  methods: {
    langChanged(lang) {
      localStorage.Lang = lang; //this is OK
      this.$router.go();
    },

    reloadChild() {
      //alert("hello guys")
      // console.log("id", "refreshing2 " + this.componentKey);
      this.componentKey += 1;
    },
  },

  mounted() {
    //FOR LANGUAGE
    if (localStorage.Lang != null) this.$i18n.locale = localStorage.Lang;

    this.$root.vtoast = this.$refs.vtoast;
    //this.$nextTick(()=>{ this.$root.vtoast = this.$refs.vtoast });

    // console.log("type of permissions", typeof this.global_permissions);
    // console.log("list of permissions", this.global_permissions);
  },
};
</script>

<style scoped>
/* v-footer{
  position:fixed;
  bottom:0;
  } 

  .lang_menu{
    width: 70px;
    padding: 5px;
  }

  .main{
    margin: 0 1cm 1cm 1cm;
  } */

.rotate-btn {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
</style>
